(function () {
	if (!Element.prototype.closest) {
		if (!Element.prototype.matches) {
			Element.prototype.matches =
				Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
		}
		Element.prototype.closest = function (s) {
			var el = this;
			var ancestor = this;
			if (!document.documentElement.contains(el)) return null;
			do {
				if (ancestor.matches(s)) return ancestor;
				ancestor = ancestor.parentElement;
			} while (ancestor !== null);
			return null;
		};
	}

	// Keep mobile menu viewport-sized: header section uses transform for sticky behaviour,
	// which makes fixed descendants clip to the header (~header height only).
	function reparentMobileMenuDrawer() {
		var el = document.getElementById("mobile-menu-drawer");
		if (el && el.parentNode !== document.body) {
			document.body.appendChild(el);
		}
	}
	reparentMobileMenuDrawer();
	document.addEventListener("DOMContentLoaded", reparentMobileMenuDrawer);

	var settings = {
		speedOpen: 50,
		speedClose: 350,
		activeClass: "is-active",
		visibleClass: "is-visible",
		selectorTarget: "[data-drawer-target]",
		selectorTrigger: "[data-drawer-trigger]",
		selectorClose: "[data-drawer-close]",
	};

	function toggleAccessibility(trigger) {
		if (!trigger) return;
		if (trigger.getAttribute("aria-expanded") === "true") {
			trigger.setAttribute("aria-expanded", false);
		} else {
			trigger.setAttribute("aria-expanded", true);
		}
	}

	function dismissOtherDrawers(keepDrawer) {
		document.querySelectorAll(settings.selectorTarget).forEach(function (el) {
			if (el === keepDrawer || !el.classList.contains(settings.activeClass)) return;
			el.classList.remove(settings.visibleClass);
			el.classList.remove(settings.activeClass);
			var tr = document.querySelector(
				'[data-drawer-trigger][aria-controls="' + el.id + '"]'
			);
			if (tr && tr.getAttribute("aria-expanded") === "true") {
				tr.setAttribute("aria-expanded", "false");
			}
		});
	}

	function openDrawer(trigger) {
		var id = trigger.getAttribute("aria-controls");
		var target = id ? document.getElementById(id) : null;
		if (!target) return;

		dismissOtherDrawers(target);

		target.classList.add(settings.activeClass);
		document.documentElement.style.overflow = "hidden";
		toggleAccessibility(trigger);

		setTimeout(function () {
			target.classList.add(settings.visibleClass);
		}, settings.speedOpen);
	}

	function closeDrawer(element) {
		var drawerRoot = element.closest(settings.selectorTarget);
		if (!drawerRoot) return;

		drawerRoot.classList.remove(settings.visibleClass);
		document.documentElement.style.overflow = "";

		var trigger = document.querySelector(
			'[data-drawer-trigger][aria-controls="' + drawerRoot.id + '"]'
		);
		if (trigger && trigger.getAttribute("aria-expanded") === "true") {
			toggleAccessibility(trigger);
		}

		setTimeout(function () {
			drawerRoot.classList.remove(settings.activeClass);
		}, settings.speedClose);
	}

	/* Swipe-to-close: left drawer → swipe left; right drawer (cart) → swipe right */
	var swipeDrag = null;

	/* Starting swipe drag + pointer capture on these targets breaks Desktop Chrome:
	   pointerup lands on .drawer__wrapper instead of e.g. a submit button, so no click activation. */
	var drawerSwipeIgnoredTargets =
		'a[href], button, input, textarea, select, label, summary, [role="button"], [role="link"], [data-modal-button], [contenteditable], [contenteditable="true"]';

	function isDrawerSwipePassiveTarget(el) {
		return !!(el && el.closest && el.closest(drawerSwipeIgnoredTargets));
	}

	function drawerWrapperFromEvent(target) {
		var wrapper = target.closest(".drawer__wrapper");
		if (!wrapper) return null;
		var root = wrapper.closest(settings.selectorTarget);
		if (
			!root ||
			!root.classList.contains(settings.activeClass) ||
			!root.classList.contains(settings.visibleClass)
		) {
			return null;
		}
		return { wrapper: wrapper, root: root, left: wrapper.classList.contains("drawer__wrapper--left") };
	}

	function resetWrapperStyles(wrapper) {
		wrapper.style.transition = "";
		wrapper.style.transform = "";
		wrapper.style.webkitTransform = "";
	}

	function endSwipeDrag(state, commitClose) {
		if (!state) return;
		var wrapper = state.wrapper;
		var root = state.root;
		try {
			if (state.pointerId != null) wrapper.releasePointerCapture(state.pointerId);
		} catch (e) {}
		resetWrapperStyles(wrapper);
		if (commitClose) {
			closeDrawer(root);
		}
		swipeDrag = null;
	}

	document.addEventListener(
		"pointerdown",
		function (event) {
			if (event.pointerType === "mouse" && event.button !== 0) return;
			if (swipeDrag) return;
			var info = drawerWrapperFromEvent(event.target);
			if (!info) return;
			if (isDrawerSwipePassiveTarget(event.target)) return;

			var rect = info.wrapper.getBoundingClientRect();
			swipeDrag = {
				wrapper: info.wrapper,
				root: info.root,
				left: info.left,
				startX: event.clientX,
				startY: event.clientY,
				width: rect.width,
				pointerId: event.pointerId,
				started: false,
			};
			try {
				info.wrapper.setPointerCapture(event.pointerId);
			} catch (e) {}
		},
		true
	);

	document.addEventListener(
		"pointermove",
		function (event) {
			if (!swipeDrag || event.pointerId !== swipeDrag.pointerId) return;

			var dx = event.clientX - swipeDrag.startX;
			var dy = event.clientY - swipeDrag.startY;

			if (!swipeDrag.started) {
				if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
				if (Math.abs(dy) >= Math.abs(dx)) {
					endSwipeDrag(swipeDrag, false);
					return;
				}
				swipeDrag.started = true;
				swipeDrag.wrapper.style.transition = "none";
			}

			var w = swipeDrag.width;
			var t;
			if (swipeDrag.left) {
				t = Math.min(0, Math.max(-w, dx));
			} else {
				t = Math.max(0, Math.min(w, dx));
			}
			var tx = "translateX(" + t + "px)";
			swipeDrag.wrapper.style.transform = tx;
			swipeDrag.wrapper.style.webkitTransform = tx;

			event.preventDefault();
		},
		true
	);

	document.addEventListener(
		"pointerup",
		function (event) {
			if (!swipeDrag || event.pointerId !== swipeDrag.pointerId) return;
			var state = swipeDrag;
			var dx = event.clientX - state.startX;
			var threshold = Math.min(80, state.width * 0.22);
			var meetsThreshold = state.left ? dx < -threshold : dx > threshold;
			var shouldClose = meetsThreshold && state.started;
			/* Avoid accidental link taps after a horizontal pan that snapped back */
			if (state.started && Math.abs(dx) > 14 && !shouldClose) {
				var block = function (e) {
					e.preventDefault();
					e.stopPropagation();
					document.removeEventListener("click", block, true);
				};
				document.addEventListener("click", block, true);
			}
			endSwipeDrag(state, shouldClose);
		},
		true
	);

	document.addEventListener(
		"pointercancel",
		function (event) {
			if (!swipeDrag || event.pointerId !== swipeDrag.pointerId) return;
			endSwipeDrag(swipeDrag, false);
		},
		true
	);

	document.addEventListener(
		"click",
		function (event) {
			var toggle = event.target;
			var open = toggle.closest(settings.selectorTrigger);
			var close = toggle.closest(settings.selectorClose);

			if (open) openDrawer(open);
			if (close) closeDrawer(close);

			if (open || close) event.preventDefault();
		},
		false
	);

	document.addEventListener(
		"keydown",
		function (event) {
			if (event.key !== "Escape" && event.keyCode !== 27) return;
			var drawers = document.querySelectorAll(settings.selectorTarget);
			var i;
			for (i = 0; i < drawers.length; ++i) {
				if (drawers[i].classList.contains(settings.activeClass)) {
					closeDrawer(drawers[i]);
				}
			}
		},
		false
	);
})();
